import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { Subject, throwError } from 'rxjs';
import { Observable } from 'rxjs';
//import 'rxjs/add/operator/catch';
import { takeWhile, map, catchError } from 'rxjs/operators';

// services
import { ErrorHandler } from './../../shared/services/error-handler.service';
import { AppLoaderService } from './../../shared/services/app-loader.service';

// path globals
import { API_PATH, SUBSCRIPTION_KEY, COMPLETE_BOOKING, DELETE_COMPLETE_BOOKING, GET_COMPLETED_BOOKING, STORE_LEAD_IN } from '../../shared/globals';

// models
import { PaginationObject } from '../../booking/models/pagination-bookings.interface';

interface CompleteBookingRequest {
  bookingJourneyActivity: Number;
  summaryOrder: string;
  showCancelledBookings: boolean;
  paginationResultRequest: PaginationObject;
  startDateTimeUTC?: string;
}

@Injectable({
  providedIn: 'root',
})
export class CompleteBookingService {

  private _token;

  public completeBookingSubject$: Subject<any> = new Subject();
  public pastBookingSubject$: Subject<any> = new Subject();
  public completeBookingDeletedSubject$: Subject<any> = new Subject();
  public deleteBookingItem$: Subject<any> = new Subject();
  public returnedBookingObject$: Subject<any> = new Subject();
  public returnedStoreObject$: Subject<any> = new Subject();
  public adminFilterSubject$: Subject<any> = new Subject();

  constructor (
    private _http: HttpClient,
    private _errorService: ErrorHandler,
    private _appLoaderService: AppLoaderService
  ) {}

  createAuthorizationHeader(headers: HttpHeaders, tokenFromCall?) {
    const userToken = typeof this._token === 'undefined' ? tokenFromCall : this._token;
    headers = headers.set('Authorization', 'bearer ' + userToken);
    return headers;
  }

  getCompleteBookings(showCancelledBookings: boolean, bookingType: Number, pageNumber: Number, pageSize: Number, token, date?: string) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    const request: CompleteBookingRequest = {
      bookingJourneyActivity: bookingType,
      summaryOrder: 'CollectionDateTimeAscending',
      showCancelledBookings,
      paginationResultRequest: {pageNumber: pageNumber, pageSize: pageSize}
    };

    if (typeof date !== 'undefined') {
      request.startDateTimeUTC = date;
    }

    this._http.post(API_PATH + COMPLETE_BOOKING, request, {headers: headers})
      .subscribe(
        (res:any) => {
          if (bookingType === 1) {
            this.completeBookingSubject$.next(res);
          } else {
            this.pastBookingSubject$.next(res);
          }
        },
        err => {

          if (bookingType === 1) {
            this.completeBookingSubject$.next(err);
          } else {
            this.pastBookingSubject$.next(err);
          }
          return;
        });
  }

  getFilteredCompleteBookings(request: Object, token, bookingType?: Number) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);


    this._http.post(API_PATH + COMPLETE_BOOKING, request, {headers: headers})
      .subscribe(
        (res:any) => {
          bookingType === 2 ? this.pastBookingSubject$.next(res) : this.completeBookingSubject$.next(res)
        },
        err => {
          bookingType === 2 ? this.pastBookingSubject$.next(err) : this.completeBookingSubject$.next(err)
          return;
        });
  }

  deleteBooking(request, token) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);

    this._appLoaderService.showLoader('', true);
    this._http.post(API_PATH + DELETE_COMPLETE_BOOKING, request, {headers: headers})
      .subscribe(
        res => {
          this.completeBookingDeletedSubject$.next(true);
          const messageData = {
            text: 'Your booking has been canceled successfully',
            type: 'danger',
            icon: 'alert',
            sticky: false
          };
          this._appLoaderService.hideLoader();
          this._errorService.handleCustomInfo(messageData);
        },
        err => {
          this._appLoaderService.hideLoader();
          this._errorService.handleError(err);
          this.completeBookingDeletedSubject$.next(false);
          return;
        }
      );

  }

  sendSessionToFlightResult(request, token) {
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);


    this._http.post(API_PATH + STORE_LEAD_IN, request, {headers: headers})
      .subscribe(
        (res:any) => {
          this.returnedStoreObject$.next(res);
        },
        err => {
          this._errorService.handleError(err);
          this.returnedStoreObject$.next(err);
          return;
        }
      );
  }

  getCompletedBookingForAmend(request, token) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);


    this._http.post(API_PATH + GET_COMPLETED_BOOKING, request, {headers: headers})
      .subscribe(
        (res:any) => {
          const bookingObj = res;
          this.returnedBookingObject$.next(bookingObj);
        },
        err => {
          this._errorService.handleError(err);
          this.returnedBookingObject$.next(err);
          return;
        }
      );

  }

  setAppliedFilters(obj: any) {
    this.adminFilterSubject$.next(obj);
  }

  parseReturnedData(value: any) {
    const parsed = JSON.parse(value);
    return parsed;
  }

};
